import { Router } from '@angular/router';
import { catchError, from, map, Observable, of } from 'rxjs';
import { AuthService } from '../../service/auth/auth.service';
import { NotificationService } from '../../service/core/notification.service';

/**
 * Logica comune dei guard di ruolo. Viaggiano insieme ad AccessAuthGuard (eseguiti in parallelo):
 * se l'utente non e' loggato rispondono false in silenzio, il redirect al login spetta ad AccessAuthGuard.
 * Solo un utente loggato ma senza il ruolo riceve l'avviso e il redirect alla lista.
 */
export function checkRoleAccess(
  authService: AuthService,
  router: Router,
  notificationService: NotificationService,
  hasRole: () => boolean,
  deniedMessage = 'Non sei autorizzato ad accedere a questa sezione'
): Observable<boolean> {
  return from(authService.isLoggedIn()).pipe(
    map(isUserLogged => {
      if (!isUserLogged) {
        return false;
      }
      if (hasRole()) {
        return true;
      }
      notificationService.showWarning('Accesso negato', deniedMessage);
      router.navigate(['list']);
      return false;
    }),
    catchError(() => of(false))
  );
}
